<template>
<div class="chapter">
<div class="inner_page">
<p class="IVPcenter"></p>
<p class="dedication sgc-2"><span class="char-style-override-1 sgc-1">Dedication</span></p>
<p class="dedication-verse para-style-override-9 sgc-3">To the missional leaders in the Ecclesia Network your faith, hope and love inspire me. Your willingness to explore new ways to be the church with a focus on making disciples of Jesus, through the power of the Spirit to the glory of God and for the good of the world, brings great encouragement to my heart.</p>
<p class="first"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?225ce5a3